import { MessageType } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message.types";

export type SearchResult = {
  totalResultsFound: number;
  results: Array<Device>;
};

export type Device = {
  deviceId: string;
  description: string;
  maximumDisplayValue: string;
  category: string;
  maximumValue: string;
  grading: Array<GradingQuestion>;
};

export type GradingQuestion = {
  id: string;
  question: string;
};

export type TradeInApiError = {
  title: string;
  body: string;
  type: MessageType;
  isSearchError?: boolean;
  isTechnicalError?: boolean;
};

export const TRADE_IN_SEARCH_ERROR: TradeInApiError = {
  title: "No device found",
  body: "Please check your search and try again.",
  type: "error",
  isSearchError: true,
};

export const TRADE_IN_UNAVAILABLE_WARNING: TradeInApiError = {
  title: "Trade In is not available at the moment.",
  body: "Please try again later.",
  type: "warning",
  isTechnicalError: true,
};
